<template>
  <div>
    <div class="top_nav">
      <div class="left">
        <i class="el-icon-back" @click="$router.go(-1)"></i>
        <i
          class="el-icon-s-home"
          @click="
            $router.push({
              path: '/classCourse/chapters',
              query: { id: $route.query.id },
            })
          "
        ></i>
        <span class="chapter_title">{{ currentChapterTitle }}</span>
      </div>
      <!-- <img class="logo" src="@/assets/images/whiteLogo.png" alt="logo" /> -->
      <div class="right_btns">
        <!-- <img
          class="icon"
          src="@/assets/images/icons/icon_msg_white.png"
          alt=""
          @click="$router.push('/message')"
        /> -->
        <el-dropdown trigger="click" @command="handleCommand">
          <el-image
            class="icon"
            style="width: 40px; height: 40px"
            :src="studentInfo.avatar"
            fit="cover"
          ></el-image>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-edit" command="editPass"
              >修改密码</el-dropdown-item
            >
            <el-dropdown-item
              icon="el-icon-switch-button"
              :divided="true"
              command="exit"
              >退出</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="main">
      <div class="change_area">
        <div class="file_area" :class="{ full: hide }">
          <div class="mask" v-show="showMask" :class="{ full: hide }">
            <div class="box">
              <i class="el-icon-lock"></i>
              <p>该菜单已被教师锁定</p>
            </div>
          </div>

          <keep-alive include="crouseVideo,courseware">
            <router-view
              :info="chapterInfo"
              ref="c"
              @updateTest="getTest"
            ></router-view>
          </keep-alive>
        </div>
        <div class="stretch_menu" :class="{ hide_menu: hide }">
          <div class="menu_tabs">
            <div
              class="tab"
              :class="{ active_menu: activeMenu == tab.id }"
              v-for="tab in menuTabs"
              :key="tab.id"
              @click="
                activeMenu = tab.id;
                hide = false;
              "
            >
              <el-badge
                :value="msgNum"
                :max="99"
                :hidden="tab.id != 3 || msgNum == 0 || !hide"
              >
                <img v-if="activeMenu == tab.id" :src="tab.activeIcon" alt="" />
                <img v-else :src="tab.icon" alt="" />
              </el-badge>
              <p>{{ tab.label }}</p>
            </div>
            <div class="tab control" @click="hide = !hide">
              <i
                :class="hide ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
              ></i>
            </div>
          </div>

          <keep-alive exclude="notes">
            <chapter-list
              v-if="activeMenu == 1 && !hide"
              @update="updateChapter"
            />
            <notes v-if="activeMenu == 2 && !hide" />
            <chat
              v-if="activeMenu == 3 && !hide"
              @updateMsgNum="updateMsgNum"
            />
          </keep-alive>
        </div>
      </div>
      <!-- <div class="block"></div> -->
      <div class="navs">
        <div
          class="nav"
          :class="{
            active: activeId == item.id,
            locked: item.isLock,
            hide: item.hide,
          }"
          v-for="item in navList"
          :key="item.id"
          @click="handleChange(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
    <!-- <bottom /> -->

    <el-dialog
      title="修改密码"
      :visible.sync="showEdit"
      :modal="false"
      width="50%"
      center
      class="dialog"
    >
      <el-form
        :model="ruleForm"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="旧密码" prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            type="password"
            v-model="ruleForm.newPassword"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            type="password"
            v-model="ruleForm.checkPass"
            autocomplete="off"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')" style="margin-right: 30px"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="loading"
          >{{ loading ? "提交中 ..." : "确 定" }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import bottom from "@/components/bottomNav";
import { editPass } from "@/api/user";
import { chapterInfo, chapterTest } from "@/api/chapter";
import chapterList from "./components/chapterList";
import notes from "./components/notes";
import chat from "./components/chat";
export default {
  components: {
    // bottom,
    chapterList,
    notes,
    chat,
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      showEdit: false,
      ruleForm: {
        password: "",
        newPassword: "",
        checkPass: "",
      },
      rules: {
        password: { required: true, message: "请输入旧密码", trigger: "blur" },
        newPassword: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },

      activeMenu: 1,
      menuTabs: [
        {
          id: 1,
          label: "目录",
          icon: require("@/assets/images/icons/icon_chapters.png"),
          activeIcon: require("@/assets/images/icons/icon_chapters_white.png"),
        },
        {
          id: 2,
          label: "笔记",
          icon: require("@/assets/images/icons/icon_note.png"),
          activeIcon: require("@/assets/images/icons/icon_note_white.png"),
        },
        {
          id: 3,
          label: "互动",
          icon: require("@/assets/images/icons/icon_chat.png"),
          activeIcon: require("@/assets/images/icons/icon_chat_white.png"),
        },
      ],
      hide: true,
      currentChapterTitle: "",
      navList: [
        {
          id: 1,
          label: "微课",
          path: "/courseDetail/video",
          statusText: "videoStatus",
          isLock: false,
          hide: false,
        },
        {
          id: 2,
          label: "课件",
          path: "/courseDetail/courseware",
          statusText: "imageStatus",
          isLock: false,
          hide: false,
        },
        {
          id: 4,
          label: "资料",
          path: "/courseDetail/data",
          statusText: "annexStatus",
          isLock: false,
          hide: true,
        },
        {
          id: 3,
          label: "测试",
          path: "/courseDetail/testing",
          childrenPath: ["/courseDetail/testing/reviewTest"],
          statusText: "testStatus",
          isLock: false,
          hide: false,
        },
        {
          id: 5,
          label: "实战",
          path: "/courseDetail/practice",
          statusText: "pdfStatus",
          childrenPath: [
            "/courseDetail/practice/pdf",
            "/courseDetail/practice/detail",
            "/courseDetail/practice/uploadWorks",
          ],
          isLock: false,
          hide: false,
        },
        // {
        //   id: 6,
        //   label: "抖音号",
        //   path: "/classCourse/tiktok",
        //   statusText: "douyinStatus",
        //   isLock: false,
        // },
        {
          id: 7,
          label: "作品圈",
          path: "/courseDetail/works",
          childrenPath: ["/courseDetail/works/uploadWorks"],
          statusText: "worksStatus",
          isLock: false,
          hide: false,
        },
        {
          id: 8,
          label: "教学活动",
          path: "/courseDetail/activity",
          childrenPath: [
            "/courseDetail/activity/signin",
            "/courseDetail/activity/vote",
            "/courseDetail/activity/select",
            "/courseDetail/activity/question",
            "/courseDetail/activity/discuss",
          ],
          statusText: "activityStatus",
          isLock: false,
          hide: false,
        },
        // {
        //   id: 9,
        //   label: "章节评价",
        //   path: "/classCourse/works",
        //   statusText: "appraiseStatus",
        //   isLock: false,
        //   hide: false,
        // },
        {
          id: 10,
          label: "学情统计",
          path: "/courseDetail/statistics",
          statusText: "statisticsStatus",
          isLock: false,
          hide: false,
        },
        {
          id: 11,
          label: "python在线工具",
          path: "/courseDetail/python",
          statusText: "pythonToolsStatus",
          isLock: false,
          hide: true,
        },
      ],
      activeId: 1,
      chapterInfo: {},
      alreadyDo: Boolean,
      showMask: false,
      msgNum: 0,
    };
  },
  created() {
    this.setActiveId();
    this.getInfo();
    // this.getTest();
    this.$store.dispatch("connectChat");
  },
  beforeDestroy() {
    this.$store.dispatch("closeChat");
  },
  computed: {
    stompClient() {
      return this.$store.state.stompClient;
    },
    update() {
      return this.$store.state.update;
    },
    studentInfo() {
      return this.$store.state.myInfo;
    },
  },
  watch: {
    update(val) {
      if (val) {
        this.stompClient.subscribe(
          `/topic/class/chapter/change/${this.$route.query.classChapterId}`,
          (msg) => {
            // this.getInfo();
            this.chapterInfo = JSON.parse(msg.body);
          }
        );
        this.$store.commit("SET_UPDATE", false);
      }
    },
    $route(val) {
      this.currentChapterTitle = val.query.chapterTitle;
      this.getInfo();
      this.setActiveId();
    },
    alreadyDo() {
      if (this.activeId == 3)
        this.handleChange(
          this.navList.find((item) => {
            return item.id == 3;
          })
        );
    },
    chapterInfo: {
      handler(val) {
        this.navList.forEach((item) => {
          item.isLock = val[item.statusText] == "CLOSE";
        });
        // console.log(this.$route.path);
        this.navList.forEach((item) => {
          if (
            this.$route.path == item.path ||
            this.$route.path == item.childrenPath
          ) {
            this.showMask = item.isLock;
          }
        });
      },
      deep: true,
    },
    "chapterInfo.lookTestAnswer"() {
      this.getTest();
    },
  },
  methods: {
    handleCommand(command) {
      if (command == "exit") {
        this.$confirm("确定要退出吗?", {
          type: "warning",
        })
          .then(() => {
            this.$router.push("/");
            localStorage.removeItem("Authorization");
            sessionStorage.removeItem("Authorization");
            this.$store.commit("SET_LOGIN", false);
            this.$store.commit("CLEAR_MYINFO");
          })
          .catch(() => {});
      } else if (command == "editPass") {
        this.showEdit = true;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          editPass({
            password: this.ruleForm.password,
            newPassword: this.ruleForm.newPassword,
          }).then((res) => {
            this.loading = false;
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.resetForm(formName);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.showEdit = false;
    },

    // 测试信息
    getTest() {
      // this.$loading.show();
      chapterTest(this.$route.query.classChapterId).then((res) => {
        // this.$loading.hide();
        if (res.code == 0) {
          this.alreadyDo = !!res.data.submitTime;
          res.data.questionList = this.sortQuestions(res.data.questionList);
          this.$store.commit("SET_TEST", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    sortQuestions(arr) {
      let list = [];
      let radio = arr.filter((item) => {
        return item.type == "RADIO";
      });
      let checkbox = arr.filter((item) => {
        return item.type == "CHECKBOX";
      });
      let boolean = arr.filter((item) => {
        return item.type == "BOOLEAN";
      });
      list = [...list, ...radio, ...checkbox, ...boolean];
      return list;
    },
    //章节详情
    async getInfo() {
      const res = await chapterInfo(this.$route.query.classChapterId);
      this.chapterInfo = res.data;
      this.handleHideMenu();
      if (this.activeId == 5) this.setActiveName();
    },
    handleHideMenu() {
      this.navList.find((item) => {
        return item.id == 4;
      }).hide = this.chapterInfo.annexCount == 0;

      this.navList.find((item) => {
        return item.id == 5;
      }).hide =
        !this.chapterInfo.sz &&
        !this.chapterInfo.mock &&
        !this.chapterInfo.teamGrade;

      this.navList.find((item) => {
        return item.id == 11;
      }).hide = !this.chapterInfo.showPythonTools;
    },
    setActiveId() {
      this.currentChapterTitle = this.$route.query.chapterTitle;
      let activeTab = this.navList.find((item) => {
        return item.path == this.$route.path;
      });
      if (!activeTab) {
        this.navList.forEach((item) => {
          if (item.childrenPath) {
            if (this.$route.path.indexOf(item.path) != -1) activeTab = item;
          }
        });
      }
      this.activeId = activeTab.id;
    },
    handleChange(nav) {
      if (nav.isLock) {
        this.$message.warning("该菜单已被教师锁定");
        return;
      }
      this.showMask = false;
      this.hide = true;
      this.activeId = nav.id;

      if (nav.id == 3 && this.alreadyDo)
        this.$router.push({
          path: nav.childrenPath[0],
          query: {
            id: this.$route.query.id,
            classChapterId: this.$route.query.classChapterId,
            chapterTitle: this.$route.query.chapterTitle,
          },
        });
      else
        this.$router.push({
          path: nav.path,
          query: {
            id: this.$route.query.id,
            classChapterId: this.$route.query.classChapterId,
            chapterTitle: this.$route.query.chapterTitle,
          },
        });
    },
    async updateChapter() {
      await this.getInfo();
      this.getTest();
      if (this.activeId == 1) {
        this.$refs.c.historyId = null;
        clearInterval(this.$refs.c.timerId);
      } else if (this.activeId == 2) {
        this.$refs.c.getPPT();
        clearInterval(this.$refs.c.timerId);
        setTimeout(() => {
          this.$refs.c.handleStart();
        }, 3000);
      } else if (this.activeId == 4) {
        this.$refs.c.getAnnexList();
      } else if (this.activeId == 5) {
        if (
          !this.chapterInfo.sz &&
          !this.chapterInfo.mock &&
          !this.chapterInfo.teamGrade
        ) {
          this.$router.replace({
            path: "/courseDetail/video",
            query: {
              id: this.$route.query.id,
              classChapterId: this.$route.query.classChapterId,
              chapterTitle: this.$route.query.chapterTitle,
            },
          });
          this.activeId = 1;
        }
        this.setActiveName();
        if (this.chapterInfo.teamGrade) {
          this.$refs.c.getStatus();
          if (this.$refs.c.$refs.grade) {
            this.$refs.c.$refs.grade.getList();
            // this.$refs.c.$refs.rankingList.getRanking();
          }
        }
      } else if (this.activeId == 7) {
        this.$refs.c.$refs.detailWorks.getList();
        this.$refs.c.$refs.detailWorks.getTaskList();
      } else if (this.activeId == 8) {
        this.$refs.c.getList();
      } else if (this.activeId == 10) {
        this.$refs.c.getStatistics();
      }
    },
    updateMsgNum(val) {
      this.msgNum = val;
    },
    setActiveName() {
      if (this.chapterInfo.sz) {
        this.$refs.c.activeName = "1";
        this.$refs.c.getList();
      } else if (this.chapterInfo.mock) {
        this.$refs.c.activeName = "2";
      } else if (this.chapterInfo.teamGrade) {
        this.$refs.c.activeName = "3";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.top_nav {
  position: relative;
  padding: 0 20px;
  height: 59px;
  line-height: 58px;
  text-align: center;
  background-color: #1977f5;

  .left {
    float: left;

    .el-icon-s-home,
    .el-icon-back,
    .chapter_title {
      font-size: 16px;
      color: #fff;
      cursor: pointer;
      vertical-align: middle;

      &.el-icon-s-home {
        margin: 0 20px;
        font-size: 20px;
      }

      &.el-icon-back {
        font-size: 20px;
      }

      &.chapter_title {
        display: inline-block;
        max-width: 420px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
      }
    }
  }

  .logo {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 173px;
  }

  .right_btns {
    float: right;
    padding: 10px 0;
    height: 59px;
    .el-dropdown {
      height: 100%;
      .icon {
        border-radius: 50%;
        box-shadow: -2px 2px 6px rgba(83, 83, 83, 0.5);
        cursor: pointer;
      }
    }
  }
}
.main {
  height: calc(100vh - 59px - 60px);

  .change_area {
    position: relative;
    width: 100%;
    // height: 730px;
    height: calc(100vh - 59px - 60px);
    overflow: hidden;

    .file_area {
      float: left;
      width: calc(100% - 346px);
      // height: 730px;
      height: 100%;
      transition: width 0.3s ease;
      background-color: rgb(248, 248, 248);

      &.full {
        width: 100%;
      }
      .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: calc(100% - 346px);
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: width 0.3s ease;
        z-index: 1888;
        &.full {
          width: 100%;
        }
        .box {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          .el-icon-lock {
            font-size: 150px;
            color: #fff;
          }
          p {
            margin-top: 10px;
            font-size: 20px;
            color: #fff;
          }
        }
      }
    }

    .stretch_menu {
      float: right;
      position: relative;
      width: 346px;
      // height: 730px;
      height: 100%;
      background: #444655;
      transition: width 0.3s ease;
      z-index: 1999;

      &.hide_menu {
        width: 0;
      }

      .menu_tabs {
        position: absolute;
        left: -70px;
        top: 50%;
        transform: translateY(-50%);
        width: 70px;
        // height: 300px;
        z-index: 9999;

        .tab {
          padding: 10px 0;
          text-align: center;
          background-color: #444655;
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          color: #969696;
          border-right: solid 1px #3c3d41;
          cursor: pointer;

          p {
            margin-top: 5px;
            font-size: 14px;
          }

          img {
            width: 36px;
            height: 36px;
          }

          &.active_menu {
            background-color: #1976f5;
            color: #fff;
          }

          &:nth-child(2) {
            border-top: solid 1px #3c3d41;
            border-bottom: solid 1px #3c3d41;
          }

          &.control {
            border-top: solid 1px #3c3d41;
            color: #fff;
            font-size: 20px;
          }
        }
      }
    }
  }

  // .block {
  //   height: 52px;
  //   background: #001d82;
  // }

  .navs {
    padding: 8px 60px 0;
    height: 60px;
    background: #1977f5;
    white-space: nowrap;

    .nav {
      display: inline-block;
      margin-right: 5px;
      padding: 10px 20px;
      text-align: center;
      color: #f9f871;
      border-radius: 10px;
      font-size: 20px;
      cursor: pointer;
      user-select: none;

      &.active {
        color: #1977f5;
        background: #f9f871;
      }

      &.locked {
        color: #ccc;
        cursor: not-allowed;
        &.active {
          color: #8abdffd5;
        }
      }

      &.hide {
        display: none;
      }
    }
  }
}

::v-deep .dialog {
  .el-dialog__body {
    padding-left: 90px;
    padding-right: 90px;
  }
}
</style>